import porta from 'porta';
import nl from 'porta/src/i18n/nl';

import { Controller } from 'stimulus';

class FormValidationController extends Controller {
  connect() {
    porta({
      target: this.element,
      messages: nl,
      onValidate: (formElement) => {
        const dealerSelector = formElement.querySelector('[data-controller="dealer-locator"]');

        if (dealerSelector) {
          const controller = this.application.getControllerForElementAndIdentifier(dealerSelector, 'dealer-locator');
          return controller.validate();
        }

        return true;
      },
      onValid: () => {
        return true;
      },
    });
  }
}

export default FormValidationController;
